// extracted by mini-css-extract-plugin
module.exports = {"login":"LoginPage_login__lW7y7"};